module.exports = __webpack_public_path__ + "img/albums-icon.4b12fc71.svg";